// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"72d492c2","31":"b8f0dbc2","53":"61e5c660","204":"b8b33779","236":"20fad244","257":"eb36b716","385":"691cfb29","453":"4bebc8bc","553":"73bd7148","572":"1ca48592","602":"b2482ce4","638":"75226942","651":"64ca37ca","734":"010706a1","874":"7d356898"}[chunkId] + ".chunk.js";
};